<template>
  <v-container fluid class="language-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Language</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Photo</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Create Language</p>
                        <v-text-field
                          class="mb-4"
                          v-model="language.languagecode"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Language Code"
                          persistent-hint
                          single-line hint="Enter the language Code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="language.languagename"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Language Name"
                          persistent-hint
                          single-line hint="Enter the language name">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="language.languageinfo"
                          outlined
                          dense
                          placeholder="Language Info"
                          persistent-hint
                          single-line hint="Enter the language name info">
                        </v-text-field>
                        <v-switch
                          v-model="language.languagestatus"
                          color="primary"
                          v-bind:label="language.languagestatus"
                          value="Active"
                        ></v-switch>
                        <div class="d-flex justify-center">
                        <v-btn
                            to="/language/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                      </div>

                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Upload Photo</p>
                        <p>Photo:</p>

                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="createLanguage()">
                            Save
                          </v-btn>
                        </div>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      imageurl: undefined,
      language: {
        languagestatus: 'Active'
      },
      items: ['Language', 'Other Language'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },

  methods: {
    ...mapActions('Language', ['createLanguageRequest','getLanguagesRequest']),
    checkError(){
      if(!this.language.languagecode){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.language.languagename){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    async createLanguage() {
      console.log(this.language)
      await this.createLanguageRequest(this.language);
      router.push('/language/list');
    },
    createImage(file) {
      const reader = new FileReader();

      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.language.languageimage = file;
      this.language.imagename = file.name;
      this.createImage(file);
    }
  },
  computed: {
    ...mapState('Language', ['isReceiving'])
  }

}
</script>

<style src="./Add.scss" lang="scss"></style>
